export const METADATA_SEPARATOR = ', ';

export interface ProcessSubmitVariable {
  value: boolean | string | null;
  type: 'String' | 'Boolean' | 'Date' | 'Long';
}
export interface ProcessSubmitVariables {
  [id: string]: ProcessSubmitVariable;
}
